import React, { Component } from "react"
import { Link } from "gatsby"
import styled from "@emotion/styled"
import { AppConsumer } from "../../context/context"
import { isBrowser, signOut } from "../../services/firebase"

export class NavMenu extends Component {
  render() {
    return (
      <AppConsumer>
        {value => {
          if (isBrowser) {
            const { firebaseApp, isAuthenticated } = value

            if (isAuthenticated) {
              return (
                <div className="navbar-start has-text-centered">
                  <Link
                    className="navbar-item"
                    to="/app/sponsors"
                    onClick={this.props.toggleHamburger}
                  >
                    Sponsors
                  </Link>
                  <Link
                    className="navbar-item"
                    to="/app/opportunities"
                    onClick={this.props.toggleHamburger}
                  >
                    Opportunities
                  </Link>
                  <Link
                    className="navbar-item"
                    to="/featured"
                    onClick={this.props.toggleHamburger}
                  >
                    Featured
                  </Link>
                  <Link
                    className="navbar-item"
                    to="/blog"
                    onClick={this.props.toggleHamburger}
                  >
                    Blog
                  </Link>
                  <div className="navbar-item has-dropdown is-hoverable">
                    <Link className="navbar-link" to="/about" onClick={this.props.toggleHamburger}>About</Link>


                    <div className="navbar-dropdown">
                      <Link className="navbar-item" to ='/youtube-sponsorships' onClick={this.props.toggleHamburger}>Find YouTube Sponsorships</Link>
                      <Link className="navbar-item" to ='/gamer-sponsorships' onClick={this.props.toggleHamburger}>Find Sponsorships for Gamers</Link>
                      <Link className="navbar-item" to ='/podcast-sponsorships' onClick={this.props.toggleHamburger}>Find Sponsorships for Podcasters</Link>
                      <Link className="navbar-item" to ='/support/faq' onClick={this.props.toggleHamburger}>Frequently Asked Questions</Link>
                      <Link className="navbar-item" to ='/support' onClick={this.props.toggleHamburger}>Support</Link>
                    </div>
                  </div>

                  <MobileMenuDivider className="navbar-item is-hidden-desktop"></MobileMenuDivider>

                  <Link
                    className="navbar-item is-hidden-desktop"
                    to="/app/post/opportunity"
                    onClick={this.props.toggleHamburger}
                  >
                    Post New Opportunity
                  </Link>
                  <Link
                    className="navbar-item is-hidden-desktop"
                    to="/app/bizbio"
                    onClick={this.props.toggleHamburger}
                  >
                    My bizb.io
                  </Link>
                  <Link
                    className="navbar-item is-hidden-desktop"
                    to="/app/profile"
                    onClick={this.props.toggleHamburger}
                  >
                    My Account
                  </Link>
                  <Link
                    className="navbar-item is-hidden-desktop"
                    to="/app/notifications"
                    onClick={this.props.toggleHamburger}
                  >
                    My Notifications
                  </Link>
                  <Link
                    className="navbar-item is-hidden-desktop"
                    to={`/app/posts-by-user/${
                      firebaseApp.auth.currentUser
                        ? firebaseApp.auth.currentUser.uid
                        : null
                    }`}
                    onClick={this.props.toggleHamburger}
                  >
                    My Posts
                  </Link>
                  <CustomNavDiv
                    className="navbar-item is-hidden-desktop"
                    onClick={signOut.bind(this, firebaseApp)}
                  >
                    Log Out
                  </CustomNavDiv>
                </div>
              )
            } else {
              return (
                <div className="navbar-start has-text-centered">
                  <Link
                    className="navbar-item"
                    to="/app/sponsors"
                    onClick={this.props.toggleHamburger}
                  >
                    Sponsors
                  </Link>
                  <Link
                    className="navbar-item"
                    to="/app/opportunities"
                    onClick={this.props.toggleHamburger}
                  >
                    Opportunities
                  </Link>
                  <Link
                    className="navbar-item"
                    to="/featured"
                    onClick={this.props.toggleHamburger}
                  >
                    Featured
                  </Link>
                  <Link
                    className="navbar-item"
                    to="/blog"
                    onClick={this.props.toggleHamburger}
                  >
                    Blog
                  </Link>

                  <MobileMenuDivider className="navbar-item is-hidden-desktop"></MobileMenuDivider>

                  <div className="navbar-item has-dropdown is-hoverable">
                    <Link className="navbar-link" to="/about" onClick={this.props.toggleHamburger}>About</Link>


                    <div className="navbar-dropdown">
                      <Link className="navbar-item" to ='/youtube-sponsorships' onClick={this.props.toggleHamburger}>Find YouTube Sponsorships</Link>
                      <Link className="navbar-item" to ='/gamer-sponsorships' onClick={this.props.toggleHamburger}>Find Sponsorships for Gamers</Link>
                      <Link className="navbar-item" to ='/podcast-sponsorships' onClick={this.props.toggleHamburger}>Find Sponsorships for Podcasters</Link>
                      <Link className="navbar-item" to ='/support/faq' onClick={this.props.toggleHamburger}>Frequently Asked Questions</Link>
                      <Link className="navbar-item" to ='/support' onClick={this.props.toggleHamburger}>Support</Link>
                    </div>
                  </div>

                  <MobileMenuDivider className="navbar-item is-hidden-desktop"></MobileMenuDivider>

                  <Link
                    to="/app/login"
                    className="navbar-item is-hidden-desktop"
                    onClick={this.props.toggleHamburger}
                  >
                    Log In
                  </Link>
                </div>
              )
            }
          } else {
            return <React.Fragment></React.Fragment>
          }
        }}
      </AppConsumer>
    )
  }
}

const CustomNavDiv = styled.div`
  cursor: pointer;
  font-weight: bold;
  :hover {
    background-color: whitesmoke;
    color: #fd49a0;
  }
`

const MobileMenuDivider = styled.span`
  border-bottom: 2px solid whitesmoke;
  line-height: 0;
  padding: 0;
`

export default NavMenu
